import Vue from 'vue'
import Vuex from 'vuex'
// import state from './state'
// import mutations from './mutations'

Vue.use(Vuex)

const state={ 
  integral: '',//优惠券搜索的内容
  keyword: '',//搜索页
  coupon: {},//下单选择优惠券
  price: 0,//下单的金额，用在选优惠券
  address_id: '',//下单选择地址
  logistics: '', //查看物流接口
  pay:{} //支付
};

const getters = {   //实时监听state值的变化(最新状态)
  isShow(state) {  //方法名随意,主要是来承载变化的showFooter的值
     return state.keyword
  }
};
const mutations = {
  setKeyword(state,keyword) {   //自定义改变state初始值的方法，这里面的参数除了state之外还可以再传额外的参数(变量或对象);
      state.keyword = keyword;
  },
  setCoupon(state,coupon) {
    state.coupon = coupon;
  },
  setPrice(state,price) {
    state.price = price;
  },
  setAddressId(state,address_id) {
    state.address_id = address_id;
  },
  setIntegral(state,integral) {
    state.integral = integral;
  },
  setLogistics(state,logistics) {
    state.logistics = logistics;
  },
  setPay(state,pay){
    state.pay = pay;
  }
};

export default new Vuex.Store({
  state,
  getters,
  mutations
})



// WEBPACK FOOTER //
// ./src/store/index.js